export default __webpack_public_path__ + "static/media/ic-check.6da1bfb1.svg";